import React, { Component } from 'react'
import PropTypes from 'prop-types'

export default function(WrappedComponent) {
  class Container extends Component {
    static displayName = 'MarkedForDesignersModuleContainer'

    static propTypes = {
      allRugs: PropTypes.array.isRequired,
      exportToExcel: PropTypes.func.isRequired,
      filteredRugs: PropTypes.array.isRequired,
      getRugs: PropTypes.func.isRequired,
      layout: PropTypes.string.isRequired,
      limit: PropTypes.number.isRequired,
      pagination: PropTypes.object.isRequired,
      previewOpen: PropTypes.bool.isRequired,
      rugsDone: PropTypes.bool.isRequired,
      rugsError: PropTypes.bool.isRequired,
      rugsPending: PropTypes.bool.isRequired,
      setPage: PropTypes.func.isRequired,
      setSortBy: PropTypes.func.isRequired,
      sortBy: PropTypes.string.isRequired,
      sortOrder: PropTypes.string.isRequired,
      toggleLayout: PropTypes.func.isRequired,
      toggleLimit: PropTypes.func.isRequired,
      togglePreview: PropTypes.func.isRequired,
      toggleSortOrder: PropTypes.func.isRequired,
      user: PropTypes.object.isRequired,
    }

    componentDidMount() {
      const { getRugs, rugsDone } = this.props

      if (!rugsDone) {
        getRugs()
      }
    }

    handleExportToExcel = e => {
      const { exportToExcel, allRugs } = this.props

      e.preventDefault()
      exportToExcel(allRugs)
    }

    handleSort = column => {
      const { setSortBy, sortBy, toggleSortOrder } = this.props

      if (sortBy === column) {
        toggleSortOrder()
      } else {
        setSortBy(column)
      }
    }

    setPage = page => {
      const { setPage } = this.props

      setPage(page)
      window.scrollTo(0, 0)
    }

    render() {
      const { filteredRugs, rugsError, rugsPending } = this.props

      return (
        <WrappedComponent
          handleExportToExcel={this.handleExportToExcel}
          handleSort={this.handleSort}
          hasError={rugsError}
          loaderPending={rugsPending && !rugsError}
          rugs={filteredRugs}
          setPage={this.setPage}
          {...this.props}
        />
      )
    }
  }

  return Container
}
